import { useSelector } from "react-redux";
import { useConectividadApi } from "./service";

export const useParametrosService = () => {
    const { serverData } = useConectividadApi();
    const session = useSelector(state => state.session);

    /**
   * @methodApi get.
   * @description  Método encargado de obtener una lista de parametros
   */
    const get = async () => {
        try {
            const options = {
                method: 'GET',
                url: '/parametros',
                headers: {
                    Authorization: `Bearer ${session.credentials.accessToken}`
                }
            };
            return await serverData(options).then(response => {
                let data = response;
                if (data) {
                    return data;
                }
            });
        } catch (err) {
            console.error(err);
        }
    }
    /**
* @methodApi post.
* @description  Método encargado de crear parametros
*/
    const post = async (values) => {
        try {
            const options = {
                method: 'POST',
                url: '/parametros',
                headers: {
                    Authorization: `Bearer ${session.credentials.accessToken}`
                },
                data: values
              };
            try {
                await serverData(options);
            } catch (error) {
                let { data } = error;
                alert(data.msg);
            }
        } catch (error) {
            let { data } = error;
            alert(data.msg);
        }
    }
/**
* @methodApi v.
* @description  Método encargado de actualizar parametros
*/
    const put = async (idParametro, values) => {
        try {
            const options = {
                method: 'PUT',
                url: `/parametros/${idParametro}`,
                headers: {
                    Authorization: `Bearer ${session.credentials.accessToken}`
                },
                data: values
              };
            try {
                await serverData(options);
            } catch (error) {
                let { data } = error;
                alert(data.msg);
            }
        } catch (error) {
            let { data } = error;
            alert(data.msg);
        }
    }
    return {
        //Api Parametros
        get,
        post,
        put,
    }
}